import React from 'react';
import TasksList from './TasksList';

interface HotelTasksListProps {
  hotelId: number;
}

export default function HotelTasksList(props: HotelTasksListProps) {
  return (
    <TasksList
      mode="hotel"
      hotelId={props.hotelId}
      hideFilters={false}
      hideSettings={true}
    />
  );
}